import Loader from "../Loader/Loader.component";

export default function TableDataLoading() {
  return (
    <tr>
      <td colSpan={100} className="text-center py-5">
        <Loader type="lg" variant="blue" />
      </td>
    </tr>
  );
}
